import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { setModal } from '../../../Features/couponsSlice';
import { AddCouponFormContext } from '../../../Context/Coupons/AddCouponFormContext';
import SelectedProducts from './SelectedProducts';
import SelectedCategoryCollection from './SelectedCategoryCollection';
import SelectedCustomCollection from './SelectedCustomCollection';

function SelectCollectionOrProduct() {
    const dispatch = useDispatch();

    const { selectionType, selectedProducts, selectedCollection, selectedCustomCollection, formErrors } = useContext(AddCouponFormContext);

    const handleOptionChange = (event) => {
        if(event.target.value === 'category-collection') {
            dispatch(setModal('select-category-collection'));
        }

        if(event.target.value === 'custom-collection') {
            dispatch(setModal('select-custom-collection'));
        }

        if(event.target.value === 'product') {
            dispatch(setModal('select-product'));
        }
    };

    return (
        <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
            <div className="flex items-center justify-between">
            <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Set Collections or Products</h1>

                <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.collectionOrProduct}</p>
            </div>

            <div className="flex flex-col gap-2 w-fit">
                <div className="flex items-center gap-2">
                    <label htmlFor='category-collection-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                        <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${selectionType === 'category-collection' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                            {
                                selectionType === 'category-collection' && 
                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                            }
                        </div>
                    </label>

                    <label htmlFor="category-collection-radio" className='font-normal text-[16px] leading-8 text-[#121212] cursor-pointer select-none'>
                        <input 
                            id='category-collection-radio'
                            value='category-collection' 
                            type="radio" 
                            checked={selectionType === 'category-collection'} 
                            onChange={handleOptionChange} 
                            className='hidden' 
                        />
                        Set Category Collection
                    </label>
                </div>

                <div className="flex items-center gap-2">
                    <label htmlFor='custom-collection-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                        <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${selectionType === 'custom-collection' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                            {
                                selectionType === 'custom-collection' && 
                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                            }
                        </div>
                    </label>

                    <label htmlFor="custom-collection-radio" className='font-normal text-[16px] leading-8 text-[#121212] cursor-pointer select-none'>
                        <input 
                            id='custom-collection-radio'
                            value='custom-collection' 
                            type="radio" 
                            checked={selectionType === 'custom-collection'} 
                            onChange={handleOptionChange} 
                            className='hidden' 
                        />
                        Set Custom Collection
                    </label>
                </div>

                <div className="flex items-center gap-2">
                    <label htmlFor='product-radio' className="cursor-pointer w-6 h-6 flex items-center justify-center">
                        <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${selectionType === 'product' ? 'border-primaryColor' : 'border-[#757575]'}`}>
                            {
                                selectionType === 'product' && 
                                <div className="w-2 h-2 rounded-full bg-primaryColor"></div>
                            }
                        </div>
                    </label>

                    <label htmlFor="product-radio" className='font-normal text-[16px] leading-8 text-[#121212] cursor-pointer select-none'>
                        <input 
                            id='product-radio'
                            value='product' 
                            type="radio" 
                            checked={selectionType === 'product'} 
                            onChange={handleOptionChange} 
                            className='hidden' 
                        />
                        Set Product
                    </label>
                </div>
            </div>

            {
                selectedProducts.length > 0 && 
                <SelectedProducts />
            }

            {
                Object.keys(selectedCollection).length > 0 && 
                <SelectedCategoryCollection />
            }

            {
                Object.keys(selectedCustomCollection).length > 0 && 
                <SelectedCustomCollection />
            }
        </div>
    );
}

export default SelectCollectionOrProduct;
